import React from "react";
import { IoCheckmark } from "react-icons/io5";
import styles from "./authForm.module.css";

const STEPS = ["Create account", "Verify email"] as const;

/**
 * Two-step progress shared by signup and email verification.
 */
export function AuthStepper({ current }: { current: 1 | 2 }) {
  return (
    <ol className={styles.stepper} aria-label="Signup progress">
      {STEPS.map((label, i) => {
        const position = i + 1;
        const done = position < current;
        const isCurrent = position === current;
        const state = done
          ? styles.stepDone
          : isCurrent
            ? styles.stepCurrent
            : "";

        return (
          <li
            key={label}
            className={`${styles.step} ${state}`}
            aria-current={isCurrent ? "step" : undefined}
          >
            <span className={styles.stepDot} aria-hidden="true">
              {done ? <IoCheckmark /> : position}
            </span>
            <span className={styles.stepLabel}>{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
